import PropTypes from 'prop-types';
// ** React Imports
import { useEffect } from 'react';
import { NavLink } from 'react-router-dom';

// ** Utils
import { useDesignContext } from '../../../../../../providers';
import Icon from '../../../../../../components/Icon';

function VerticalMenuHeader({
  menuCollapsed,
  setMenuCollapsed,
  setMenuVisibility,
  setGroupOpen,
  menuHover
}) {
  const { AppLogo, appName } = useDesignContext();

  // ** Reset open group
  useEffect(() => {
    if (!menuHover && menuCollapsed) setGroupOpen([]);
  }, [menuHover, menuCollapsed, setGroupOpen]);

  // ** Menu toggler component
  function Toggler() {
    if (!menuCollapsed) {
      return (
        <Icon

          icon="fa-circle-dot"
          data-tour="toggle-icon"
          className="text-primary toggle-icon d-none d-xl-block"
          onClick={() => setMenuCollapsed(true)}
        />
      );
    }
    return (
      <Icon
        icon="fa-circle"

        data-tour="toggle-icon"
        className="text-primary toggle-icon d-none d-xl-block"
        onClick={() => setMenuCollapsed(false)}
      />
    );
  }

  return (
    <div className="navbar-header">
      <ul className="nav navbar-nav flex-row">
        <li className="nav-item me-auto">
          <NavLink
            to="/"
            className="navbar-brand"
          >
            <span className="brand-logo">
              <AppLogo />
            </span>
            <h2 className="brand-text mb-0">{appName}</h2>
          </NavLink>
        </li>
        <li className="nav-item nav-toggle">
          <div className="nav-link modern-nav-toggle cursor-pointer">
            <Toggler />
            <Icon
              icon="fa-times"
              onClick={() => setMenuVisibility(false)}
              className="toggle-icon icon-x d-block d-xl-none"

            />
          </div>
        </li>
      </ul>
    </div>
  );
}

VerticalMenuHeader.propTypes = {
  menuCollapsed: PropTypes.bool.isRequired,
  setMenuCollapsed: PropTypes.func.isRequired,
  setMenuVisibility: PropTypes.func.isRequired,
  setGroupOpen: PropTypes.func.isRequired,
  menuHover: PropTypes.bool.isRequired
};
export default VerticalMenuHeader;
